export const getResourceGID = (resourceName, id) => `gid://shaparency/${resourceName}/${id}`;
export const getResourceID = (gid) => gid.split('/').pop();
